import { createStore, StoreApi, useStore } from 'zustand'
import { useShallow } from 'zustand/react/shallow'

const defaultSelector = (v: any) => v

export const useStoreSafe = <TState, TResult = TState>(
  maybeStore: StoreApi<TState> | undefined,
  selector: (state: Partial<TState> | undefined) => TResult = defaultSelector as any,
): TResult | undefined => {
  return useStore((maybeStore || noopStore) as any, useShallow(selector as any)) as any as TResult
}

const noopStore = createStore(() => ({}))
